export const SHARED_ROUTE_PALETTE = [
  '#0f8fa5',
  '#2ea66d',
  '#1f9ca0',
  '#3f7ad6',
  '#6ea83a',
  '#c18a2f',
  '#158cb7',
  '#6b72d6',
  '#2e9b7f',
  '#a39a36',
];
